<script setup lang="ts">
import { addSearchTermIntoCookie } from "~/utils/cookies/searchCookies"
import { ButtonProps } from "~/components/Utils/Button.props"
import type { RelatedSearchProps } from "./RelatedSearch.props"

defineProps<RelatedSearchProps>()

const route = useRoute()

const { data: topQueries } = useLazyFetch(
  `/api/algolia/getTopSearchesByQuery/${route.query?.query}`,
  {
    server: false
  }
)

const lastQueries = useStatefulCookie("lastQueries", {
  maxAge: 2592000,
  default: () => []
})

const topQueriesMapped = computed<Array<ButtonProps>>(() => {
  return topQueries.value?.hits.map((hit) => ({
    text: hit.query
  }))
})

const { switchState } = useUIState("focus-search")
const showSearchPopup = () => switchState(true)

// See AlgoliaSearchbar component
const algoliaSearchbarQueryState = useState("searchbar-query-state")
const applyQuery = (text: string) => {
  useScrollTop()
  showSearchPopup()

  algoliaSearchbarQueryState.value = text
  lastQueries.value = addSearchTermIntoCookie(lastQueries.value, text)
}
</script>

<template>
  <div
    v-if="topQueriesMapped.length"
    class="suggestions-related_search px-4 pb-8 pt-6"
  >
    <p class="pig-bold pb-4">{{ title }}</p>

    <div class="flex flex-wrap gap-2 md:gap-6">
      <UtilsButton
        class="transform-gpu font-normal drop-shadow-01"
        v-for="tag in topQueriesMapped"
        :key="tag.text"
        theme="contained-white"
        v-bind="tag"
        @click="applyQuery(tag.text!)"
      />
    </div>
  </div>
</template>
